type httpMethod = "GET" | "POST" | "PUT" | "DELETE";

export interface IRequestConfig {
    /**
     * http请求方法
     */
    method: Uppercase<httpMethod> | Lowercase<httpMethod>;
    /**
     * 接口地址
     */
    url: string;
    /**
     * 请求Body数据
     */
    data?: any;
    /**
     * 内容类型，默认"application/json"
     */
    contentType?: string;
    /**
     *身份认证
     */
    authorization?: string;

    /**
     * 自定deader
     */
    headers?: Headers;
}


export class HttpRequestUtil {
    /**
    * 创建Http请求对象
    */
    public createXMLHttpRequest(): XMLHttpRequest {
        let xmlHttp: XMLHttpRequest;
        try {
            // Firefox, Opera 8.0+, Safari
            xmlHttp = new XMLHttpRequest();
        } catch (e) {
            // Internet Explorer
            try {
                xmlHttp = new ActiveXObject("Msxml2.XMLHTTP");
            } catch (e) {
                xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
            }
        }
        return xmlHttp;
    }

    /**
     * 同步http请求
     * 
     * @param {object} obj 请求需要的方法method 请求路径url 请求数据data
     * @param {string} obj.method 请求需要的方法method
     * @param {string} obj.url 请求路径url
     * @param {object} obj.data 请求数据data
     * @param {object} obj.headers 请求数据header
     * @param {func} successFn 请求成功之后的处理
     * @param {func} errorFn 请求失败之后的处理方法
     * @description 创建与服务器端交互的HTTP方法
     */
    public request<T>(cfg: IRequestConfig, successFn?: (result: T) => void, errorFn?: (result: Event) => void) {
        let oXmlHttp = this.createXMLHttpRequest();
        oXmlHttp.onreadystatechange = function (e: Event) {
            if (oXmlHttp.readyState === 4) {
                if (oXmlHttp.status === 200 || oXmlHttp.status === 304) {
                    let response = oXmlHttp.response || oXmlHttp.responseText;
                    let result;
                    try {
                        result = JSON.parse(response);
                    } catch (error) {
                        errorFn && errorFn(error);
                        return;
                    }
                    successFn && successFn(result);
                } else {
                    errorFn && errorFn(e);
                }
            }
        }

        oXmlHttp.open(cfg.method, cfg.url, false);

        let contentType = cfg.contentType ? cfg.contentType : "application/json";
        oXmlHttp.setRequestHeader('Content-Type', contentType);

        //是否需要认证
        if (cfg.authorization) {
            oXmlHttp.setRequestHeader('Authorization', cfg.authorization);
        }

        if (cfg.headers) {
            for (let h in cfg.headers) {
                oXmlHttp.setRequestHeader(h, cfg.headers[h]);
            }
        }

        if (cfg.data) {
            oXmlHttp.send(JSON.stringify(cfg.data));
        } else {
            oXmlHttp.send();
        }
    }


    /**
     * 通过Blob下载文件
     * @param {*} event 
     */
    public static downloadFileByBlob(res, fileType: string, fileName: string) {
        let blob = new Blob([res], {
            type: fileType
        });
        let reader = new FileReader();
        reader.readAsBinaryString(blob);

        let downloadElement = document.createElement('a');
        downloadElement.href = window.URL.createObjectURL(blob);

        // //服务器返回了指定文件名
        // if (event.headers("content-disposition") && /filename=([\w-.]*)/i.test(event.headers("content-disposition"))) {
        //     let names = event.headers("content-disposition").match(/filename=([\w-.]*)/i);

        //     if (names && names.length > 1) {
        //         fileName = names[1];
        //     }
        // }

        //如果服务器没有指定文件名，则生成时间有关的随机名称
        // if (!fileName || fileName == "") {
        //     let now = new Date();
        //     let fileFormat = "txt";
        //     let formats = event.headers("content-type").match(/(application|image)\/([\w|\w\+\w]*)(;|$)/i);
        //     if (formats && formats.length > 2) {
        //         fileFormat = formats[2];
        //     }

        //     if (fileFormat == "svg+xml") {
        //         fileFormat = "svg";
        //     }

        //     fileName = now.getFullYear().toString() + "-" + (now.getMonth() + 1).toString() + "-" + now.getDate() + "_" + Math.random() * 10000 + "." + fileFormat;
        // }

        downloadElement.download = fileName;
        document.body.appendChild(downloadElement);
        downloadElement.click();
        downloadElement.remove();
        window.URL.revokeObjectURL(downloadElement.href);
    }
}